import { KOL_ROUTE_NAME } from "@/libs/route-name";
import { RouteRecordRaw } from "vue-router";

export const kolRoute = (): RouteRecordRaw => ({
    path: '/manage/kol',
    name: KOL_ROUTE_NAME.KOL,
    component: () => import('@/pages/kol/index.vue'),
});

export const addKolRoute = (): RouteRecordRaw => ({
    path: '/manage/kol/add',
    name: KOL_ROUTE_NAME.ADD_KOL,
    component: () => import('@/pages/kol/add-kol.vue'),
});

export const kolRequestRoute = (): RouteRecordRaw => ({
    path: '/manage/kol/request',
    name: KOL_ROUTE_NAME.KOL_REQUEST,
    component: () => import('@/pages/kol/request.vue'),
});

export const kolDetailRoute = (): RouteRecordRaw => ({
    path: '/manage/kol/detail/:id',
    name: KOL_ROUTE_NAME.KOL_DETAIL,
    component: () => import('@/pages/kol/detail.vue'),
});